import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, projectFeatureKey } from './project.reducer';
import { Category } from '@rappider/rappider-sdk';
import { ProjectWithRelations } from '@rappider/rappider-sdk';

// Select the feature slice from the store
export const selectProjectState = createFeatureSelector<State>(projectFeatureKey);

// Selectors
export const selectProjects = createSelector(
  selectProjectState,
  (state: State) => state.data
);

export const selectIsProjectsLoading = createSelector(
  selectProjectState,
  (state: State) => state.loading
);

export const selectIsProjectsLoaded = createSelector(
  selectProjectState,
  (state: State) => state.isLoaded
);

export const selectPagination = createSelector(
  selectProjectState,
  (state: State) => state.pagination
);

export const selectPersonProjects = createSelector(
  selectProjectState,
  (state: State) => state.personProjects
);

export const selectIsPersonProjectsLoaded = createSelector(
  selectProjectState,
  (state: State) => state.isPersonProjectsLoaded
);

export const selectIsPublicProjectsLoading = createSelector(
  selectProjectState,
  (state: State) => state.isPublicProjectsLoading
);

export const selectPublicProjects = createSelector(
  selectProjectState,
  (state: State) => state.publicProjects
);

export const selectPublicProjectCategories = createSelector(
  selectProjectState,
  (state: State) => state.publicProjectCategories
);

/**
 * Combined selector for public projects with their categories
 * Returns both public projects and categories in a single object
 */
export const selectPublicProjectsWithCategories = createSelector(
  selectPublicProjects,
  selectPublicProjectCategories,
  (publicProjects: ProjectWithRelations[], publicProjectCategories: Category[]) => {
    if (publicProjects?.length && publicProjectCategories?.length) {
      return {
        publicProjects,
        publicProjectCategories,
        formattedCategories: publicProjectCategories.map(category => ({
          key: { text: category.title || category.name },
          value: category.name,
          actionBehavior: 'emit' as const,
          isSelected: false
        }))
      };
    }
    return {
      publicProjects: [],
      publicProjectCategories: [],
      formattedCategories: []
    };
  }
);

export const selectChangeFavorite = createSelector(
  selectProjectState,
  (state: State) => state.changeFavorite
);

export const selectLoadingActiveProjectId = createSelector(
  selectProjectState,
  (state: State) => state.loadingActiveProjectId
);

export const selectLastError = createSelector(
  selectProjectState,
  (state: State) => state.lastError
);

export const selectCopyProjectLoading = createSelector(
  selectProjectState,
  (state: State) => state.copyProjectLoading
);

export const selectRemoveCopiedProjectLoading = createSelector(
  selectProjectState,
  (state: State) => state.removeCopiedProjectLoading
);

export const selectModuleOperationsLoading = createSelector(
  selectProjectState,
  (state: State) => state.copyProjectLoading || state.removeCopiedProjectLoading
);
